import React, { useContext, useState } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  Alert,
  CircularProgress,
  List,
  ListItem,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AuthContext from "../../contexts/Islogin";

const WithdrawBatchUSDT = () => {
  const [toAddress, setToAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [addresses, setAddresses] = useState([]); // array of { address, amount }
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
    const { url } = useContext(AuthContext);

  const addEntry = () => {
    if (!toAddress || !amount) return;
    setAddresses((prev) => [...prev, { address: toAddress, amount }]);
    setToAddress("");
    setAmount("");
  };

  const removeEntry = (index) => {
    setAddresses((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    setError(null);
    setResponse(null);
    setLoading(true);
  
    try {
      const token = localStorage.getItem("token");
  
      const res = await axios.get(
        `${url}api/v1/trons/wallet/validate`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      setResponse(res.data);
    } catch (err) {
      console.error(err);
      if (err.response) {
        setError(err.response.data);
      } else {
        setError({ message: "Something went wrong." });
      }
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <Paper elevation={3}  sx={{ p: 3, width:'60%',paddingX:'10%', mx: "auto", mt: 5 }}>
      <Typography variant="h6" gutterBottom>
      اعتبار سنجی کیف پول
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" gap={2}>
          {/* <TextField
            label="آدرس مقصد"
            variant="outlined"
            value={toAddress}
            onChange={(e) => setToAddress(e.target.value)}
            fullWidth
          /> */}
          {/* <TextField
            label="مقدار"
            variant="outlined"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            type="number"
            sx={{ width: "150px" }}
          /> */}
          {/* <Button variant="outlined" onClick={addEntry}>
            اعتبار سنجی
          </Button> */}
        </Box>

        <List dense>
          {addresses.map((item, index) => (
            <ListItem
              key={index}
              secondaryAction={
                <IconButton edge="end" onClick={() => removeEntry(index)}>
                  <DeleteIcon />
                </IconButton>
              }
            >
              <Typography fontSize="14px">
                {item.address} — {item.amount}
              </Typography>
            </ListItem>
          ))}
        </List>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading }
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "اعتبار سنجی کیف پول "
          )}
        </Button>

        {response && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <Typography variant="subtitle2">پاسخ موفق:</Typography>
            <pre
              style={{
                backgroundColor: "#f9f9f9",
                padding: "10px",
                borderRadius: "5px",
                maxHeight: "300px",
                overflow: "auto",
                direction: "ltr",
              }}
            >
              {JSON.stringify(response, null, 2)}
            </pre>
          </Paper>
        )}

        {error && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <Alert severity="error">خطا</Alert>
            <pre
              style={{
                backgroundColor: "#fff0f0",
                padding: "10px",
                borderRadius: "5px",
                maxHeight: "300px",
                overflow: "auto",
                direction: "ltr",
              }}
            >
              {JSON.stringify(error, null, 2)}
            </pre>
          </Paper>
        )}
      </Box>
    </Paper>
  );
};

export default WithdrawBatchUSDT;
